import {makeAuthRequest} from '../makeApiRequest'

const apiRequest = makeAuthRequest(true)
const prefix = process.env.REACT_APP_MERGER_SERVICE_API || 'api/merger'

export const getBasketDetail = (barcode) => {
    return apiRequest({
        url: `${prefix}/set-basket/${barcode}`,
        method: 'GET'
    })
}

export const mergeBasketSet = (barcode, data) => {
    return apiRequest({
        url: `${prefix}/set-basket/${barcode}`,
        method: 'POST',
        data
    })
}

export const deleteBasketSet = (barcode, data) => {
    return apiRequest({
        url: `${prefix}/set-basket/${barcode}`,
        method: 'DELETE',
        data
    })
}